import { ROUTES } from "../constants";

const safeHasPermission = (hasPermission, key) => {
	if (typeof hasPermission !== "function" || !key) return false;
	try {
		return !!hasPermission(key);
	} catch {
		return false;
	}
};

const settingsPermissionKeys = [
	"app_settings.manage_settings",
	"app_settings.manage_order_settings",
	"app_settings.manage_inventory_settings",
	"app_settings.manage_site_settings",
	"app_settings.manage_reminder_settings",
	"app_settings.manage_cart_retention",
];

export const canAccessAnalytics = (hasPermission) => safeHasPermission(hasPermission, "analytics");

export const canAccessServices = (hasPermission) =>
	safeHasPermission(hasPermission, "service_management.view_cases") ||
	safeHasPermission(hasPermission, "service_management.view_workorders");

export const canAccessOrderHistory = (hasPermission) =>
	safeHasPermission(hasPermission, "order_management.view_order_history") ||
	safeHasPermission(hasPermission, "order_management.create_order_schedules");

export const canAccessSettings = (user) => user?.user_id === 1;

export const canAccessAdmin = (hasPermission, user) => {
	const isSuperAdmin = user?.user_id === 1;
	const checks = [
		() => safeHasPermission(hasPermission, "user_management.create_users") || safeHasPermission(hasPermission, "user_management.edit_users") || safeHasPermission(hasPermission, "user_management.delete_users"),
		() => safeHasPermission(hasPermission, "role_management.create_roles") || safeHasPermission(hasPermission, "role_management.edit_roles") || safeHasPermission(hasPermission, "role_management.delete_roles"),
		() => safeHasPermission(hasPermission, "site_management.edit_sites"),
		() => safeHasPermission(hasPermission, "document_management.create_documents") || safeHasPermission(hasPermission, "document_management.edit_documents") || safeHasPermission(hasPermission, "document_management.delete_documents"),
		() => safeHasPermission(hasPermission, "machine_provision_management.provision_machines") || safeHasPermission(hasPermission, "machine_provision_management.edit_provisions") || safeHasPermission(hasPermission, "machine_provision_management.delete_provisions"),
		() => safeHasPermission(hasPermission, "app_settings.allow_model_uploads") || safeHasPermission(hasPermission, "app_settings.manage_change_parts"),
		() => safeHasPermission(hasPermission, "order_management.create_order_schedules") || safeHasPermission(hasPermission, "order_management.edit_order_schedules") || safeHasPermission(hasPermission, "order_management.delete_order_schedules"),
		() => settingsPermissionKeys.some((perm) => safeHasPermission(hasPermission, perm)),
		() => safeHasPermission(hasPermission, "app_settings.manage_price_markups"),
		() => isSuperAdmin,
	];
	return checks.some((fn) => {
		try {
			return !!fn();
		} catch {
			return false;
		}
	});
};

export const filterPageRoutesByAccess = (routes, hasPermission, user) =>
	routes.filter((page) => {
		switch (page.href) {
			case ROUTES.ANALYTICS:
				return canAccessAnalytics(hasPermission);
			case ROUTES.SERVICES:
				return canAccessServices(hasPermission);
			case ROUTES.ADMIN:
				return canAccessAdmin(hasPermission, user);
			case ROUTES.ORDER_HISTORY:
				return canAccessOrderHistory(hasPermission);
			case ROUTES.SETTINGS:
				return canAccessSettings(user);
			default:
				return true;
		}
	});